<script lang="ts">
    import type { ProductTitle } from './ProductTitle';

    interface Props {
        title: ProductTitle;
    }

    const { title }: Props = $props();
</script>

<p class={['reptile-product-short-title__title', 'oc-copy-100', 'oc-text-color-default']}>
    <span class="reptile-product-short-title__brand">
        {title.brand}
    </span>
    {title.display}
</p>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-short-title {
        &__title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline;
            margin: 0;
            @include mixins.line-clamp(2);
        }
        &__brand {
            text-transform: uppercase;
        }
    }
</style>
